import {
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
} from '@ngrx/store';
import * as fromAuth from '../public/store/root-reducers/root.reducers';

export interface AppState {
    authState: fromAuth.RootState;
}

export const reducers: ActionReducerMap<AppState> = {
    authState: fromAuth.rootReducer,
};

export const checkIfAuth = (state: any) => state.authState.isUserLogged;
export const getCurrentLanguare = (state: any) => state.authState.appLanguage;
